/**
 * The server only puts quiz pages on a sign-in link, and the link usually opens in
 * a new tab, so sessionStorage's returnTo is gone by then. Pages that only make sense
 * once you are signed in are remembered on this device instead. On another device the
 * link falls through to the normal landing.
 */
const KEY = "bb.emailLink.return";
const RETURNABLE = /^\/(free-account|come-back|reactivate)(\?[A-Za-z0-9=&_%-]*)?$/;

export function rememberEmailLinkReturn(
  path: string = window.location.pathname + window.location.search,
): void {
  try {
    if (RETURNABLE.test(path)) localStorage.setItem(KEY, path);
    else localStorage.removeItem(KEY);
  } catch {
    /* Storage is a convenience here. */
  }
}

export function takeEmailLinkReturn(): string | null {
  try {
    const path = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    return path && RETURNABLE.test(path) ? path : null;
  } catch {
    return null;
  }
}
